/**
 * The values are coupled with the order declared on the view
 */
export enum ClientDoctorSelect {
    client = 0,
    doctor = 1
  }
